import styled from 'styled-components'
import { color } from 'utils'

export const Row = styled.div<{ tight: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${({ tight = false }) => (tight ? '56px' : '78px')};
  cursor: pointer;
  border: 1px solid ${color('dark700')};
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;

  :hover {
    background-color: ${color('dark700')};
  }
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
`

export const Right = styled.div`
  align-items: center;
  display: flex;
`
